import baseCodeFrame from 'code-frame'

let availableFont: string | undefined

export function codeFrame(code: string, line: number, column: number) {
  const errLine = code.split('\n')[line - 1]
  const beforeErr = errLine.slice(0, Math.max(0, column))
  const frame = baseCodeFrame(code, line, stringWidth(beforeErr), {
    frameSize: 6
  })
  return frame
}

function getAvailableFont(): string | undefined {
  if (availableFont) return availableFont
  const text = ' '.repeat(10)
  const canvas = document.createElement('canvas')
  const context = canvas.getContext('2d')
  if (context) {
    context.font = '16px'
    const rawWidth = context.measureText(text).width.toFixed(2)
    for (const font of ['16px Menlo', '16px Consolas', '16px Monospace']) {
      context.font = font
      const fontWidth = context.measureText(text).width.toFixed(2)
      if (fontWidth !== rawWidth) {
        availableFont = font
        return font
      }
    }
  }
  return availableFont
}

function stringWidth(text: string) {
  const canvas = document.createElement('canvas')
  const context = canvas.getContext('2d')
  const font = getAvailableFont()
  if (context && font) {
    context.font = font
    const textWidth = context.measureText(text).width
    const spaceWidth = context.measureText(' ').width
    return Math.round(textWidth / spaceWidth)
  } else {
    return text.length
  }
}
